var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentHourglassSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2919 0.264648C22.3391 0.264648 23.1852 1.05361 23.1852 2.02647C23.1852 2.99932 22.3391 3.78829 21.2919 3.78829V4.39281C21.2919 6.72832 20.2919 8.96913 18.5169 10.6208L14.5053 14.3592L18.5169 18.0976C20.2919 19.7493 21.2919 21.9901 21.2919 24.3245V24.9301C22.3391 24.9301 23.1852 25.7174 23.1852 26.6919C23.1852 27.6664 22.3391 28.4537 21.2919 28.4537H2.35821C1.31272 28.4537 0.464844 27.6664 0.464844 26.6919C0.464844 25.7174 1.31272 24.9301 2.35821 24.9301V24.3245C2.35821 21.9901 3.35578 19.7493 5.13081 18.0976L9.14474 14.3592L5.13081 10.6208C3.35578 8.96913 2.35821 6.72832 2.35821 4.39281V3.78829C1.31272 3.78829 0.464844 2.99932 0.464844 2.02647C0.464844 1.05361 1.31272 0.264648 2.35821 0.264648H21.2919ZM7.03837 7.31192H16.5585C17.1738 6.45304 17.5051 5.43889 17.5051 4.39281V3.78829H6.14494V4.39281C6.14494 5.43889 6.47628 6.45304 7.03837 7.31192ZM7.03837 21.4065H16.5585C16.3514 21.1147 16.1147 20.8394 15.8425 20.5861L11.825 16.8533L7.80755 20.5861C7.53538 20.8394 7.29871 21.1147 7.03837 21.4065Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHourglassSecondary);
export default __webpack_public_path__ + "static/media/payment_hourglass_secondary.f95965bb73d6ce3104acc907a417aeae.svg";
export { ForwardRef as ReactComponent };